
import Vue from "vue";
import moment from "moment";

export default Vue.extend({
  props: ["modal", "modal_seleccionado"],
  mounted() {
    this.mensaje = "Insertar registro"
    if (this.modal_seleccionado.id) {
      this.data.id = this.modal_seleccionado.id;
      this.data.fecha = this.modal_seleccionado.fecha;
      this.data.start = this.modal_seleccionado.start;
      this.data.end = this.modal_seleccionado.end;
      this.data.justificante_start = this.modal_seleccionado.justificante_start;
      this.data.justificante_end = this.modal_seleccionado.justificante_end;
      this.data.user_id = this.modal_seleccionado.user_id;
      this.mensaje = "Edición de registro"
    }
  },
  data() {
    var today = new Date();
    var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
    var time = today.getHours() + ":" + today.getMinutes();
    var dateTime = date + ' ' + time;
    return {
      data: {
        id: "",
        fecha: date,
        start: dateTime,
        end: dateTime,
        justificante_start: "",
        justificante_end: "",
        user_id: this.modal.userId
      },
      mensaje: ""
    };
  },
  methods: {
    formatDate(fecha: Date) {
      const d = moment(fecha, "MM/DD/YYYY").format("DD/MM/YYYY");
      return d === "Invalid date" ? fecha : d;
    },
    agregarReistro() {
      console.log("Enviando datos --> ", this.data);

      this.$http.post("Usuario/guardaRegistroAsistencia", { datos: this.data }, { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } })
        .then((r) => {
          if (r.status === 200) {
            console.log('Esto es r.data ==> ', r);

            this.$emit('enviarDatosActualizados', this.data);
            { this.$toast.open({ message: "Se ha guardado el registro correctamente.", type: "is-success", position: "is-bottom" }); }
          }

        })
    }
  }
});

function pad(number: number) {
  return number < 10 ? '0' + number : number;
}
